/* O'Cloudy · cart drawer "Pairs well with" row (sections/cart-drawer.liquid).
   Search & Discovery complementary products for the most expensive items in the cart,
   colour-matched to the sofa, added in one tap through the theme's own cart update flow. */
(() => {
  if (window.ocDrawer) return;
  const cache = new Map();
  const norm = (s) => String(s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let run = 0;

  const drawer = () => document.querySelector('cart-drawer');
  const recsEl = () => document.querySelector('cart-drawer [data-ocd-recs]');

  function fetchRecs(box, productId, cartKey) {
    const key = `${productId}|${cartKey}`; // Shopify leaves out what is already in the cart, so the cart is part of the key
    if (cache.has(key)) return cache.get(key);
    const url = `${box.dataset.url}?section_id=${encodeURIComponent(box.dataset.sectionId)}&product_id=${productId}&limit=10&intent=complementary`;
    const p = fetch(url)
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error(String(r.status)))))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const payload = doc.querySelector('[data-ocd-payload]');
        if (!payload) throw new Error('no payload');
        return [...payload.querySelectorAll('[data-ocd-rec]')].map((el) => ({ id: el.dataset.productId, handle: el.dataset.handle, html: el.outerHTML }));
      })
      .catch(() => { cache.delete(key); return null; }); // not cached, so the next open retries
    cache.set(key, p);
    return p;
  }

  /* Desktop scrolling for the row: arrows, mouse wheel, click and drag. Phones keep native swipe. */
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const bound = new WeakSet();
  const trackOf = (box) => box && box.querySelector('[data-ocd-recs-track]');
  const maxScroll = (t) => t.scrollWidth - t.clientWidth;

  function navState(box) {
    const t = trackOf(box);
    if (!t) return;
    const max = maxScroll(t);
    const over = max > 4;
    box.classList.toggle('has-overflow', over);
    const prev = box.querySelector('[data-ocd-recs-nav="-1"]');
    const next = box.querySelector('[data-ocd-recs-nav="1"]');
    if (prev) prev.disabled = !over || t.scrollLeft <= 4;
    if (next) next.disabled = !over || t.scrollLeft >= max - 4;
  }

  function stepOf(t) {
    const card = t.querySelector('[data-ocd-rec]');
    if (!card) return t.clientWidth;
    return card.getBoundingClientRect().width + (parseFloat(getComputedStyle(t).columnGap) || 0);
  }

  function page(t, dir) {
    const step = stepOf(t);
    const target = Math.max(0, Math.min(maxScroll(t), Math.round(t.scrollLeft / step + dir) * step));
    t.scrollTo({ left: target, behavior: 'smooth' });
  }

  function bindTrack(box) {
    const t = trackOf(box);
    if (!t || bound.has(t)) return;
    bound.add(t);
    let raf = 0;
    const sync = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => navState(box)); };
    t.addEventListener('scroll', sync, { passive: true });
    new MutationObserver(sync).observe(t, { childList: true });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(t);

    // Mouse wheel: one card per notch; at either end the drawer scrolls as usual.
    let acc = 0;
    let lockUntil = 0;
    t.addEventListener('wheel', (e) => {
      if (!fine.matches || e.ctrlKey || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return; // horizontal trackpad swipes stay native
      const max = maxScroll(t);
      if (max <= 4) return;
      const dir = Math.sign(e.deltaY);
      if ((dir < 0 && t.scrollLeft <= 4) || (dir > 0 && t.scrollLeft >= max - 4)) { acc = 0; return; }
      e.preventDefault();
      const now = performance.now();
      if (now < lockUntil) return;
      acc += e.deltaY * (e.deltaMode === 1 ? 33 : 1);
      if (Math.abs(acc) < 30) return;
      page(t, Math.sign(acc));
      acc = 0;
      lockUntil = now + 380;
    }, { passive: false });

    // Click and drag with the mouse.
    let drag = null;
    t.addEventListener('dragstart', (e) => e.preventDefault());
    t.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0 || maxScroll(t) <= 4) return;
      if (e.target.closest('select, button, input, label')) return;
      drag = { id: e.pointerId, x: e.clientX, left: t.scrollLeft, moved: false };
    });
    t.addEventListener('pointermove', (e) => {
      if (!drag || e.pointerId !== drag.id) return;
      const dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 6) return;
        drag.moved = true;
        t.classList.add('is-dragging');
        try { t.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      }
      t.scrollLeft = drag.left - dx;
    });
    const end = (e) => {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      const d = drag;
      drag = null;
      if (!d.moved) return;
      t.classList.remove('is-dragging');
      const step = stepOf(t);
      const moved = d.left - t.scrollLeft;
      const base = Math.round(d.left / step);
      const dir = Math.abs(moved) > step * 0.18 ? (moved > 0 ? -1 : 1) : 0;
      t.scrollTo({ left: Math.max(0, Math.min(maxScroll(t), (base + dir) * step)), behavior: 'smooth' });
      noClickUntil = performance.now() + 250; // a drag is not a click on the card under the mouse
    };
    let noClickUntil = 0;
    t.addEventListener('click', (ev) => {
      if (performance.now() < noClickUntil) { ev.preventDefault(); ev.stopPropagation(); }
    }, { capture: true });
    t.addEventListener('pointerup', end);
    t.addEventListener('pointercancel', end);
    t.addEventListener('lostpointercapture', end);
    sync();
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('cart-drawer [data-ocd-recs-nav]');
    if (!btn) return;
    const t = trackOf(btn.closest('[data-ocd-recs]'));
    if (t) page(t, Number(btn.dataset.ocdRecsNav) || 1);
  });
  window.addEventListener('resize', () => { const b = recsEl(); if (b) navState(b); }, { passive: true });

  async function refresh() {
    const box = recsEl();
    const d = drawer();
    if (!box || !d) return;
    if (!d.hasAttribute('open')) { box.dataset.stale = '1'; return; }
    box.dataset.stale = '';
    const track = box.querySelector('[data-ocd-recs-track]');
    const items = [...d.querySelectorAll('[data-ocd-item]')].map((el) => ({
      id: el.dataset.productId, price: Number(el.dataset.price) || 0, colour: el.dataset.colour || '', sofa: el.dataset.sofa === 'true',
    }));
    if (!items.length) { box.hidden = true; return; }
    const mine = ++run;
    const byPrice = [...items].sort((a, b) => b.price - a.price);
    const seeds = [...new Set(byPrice.map((i) => i.id))].slice(0, 2);
    const inCart = new Set(items.map((i) => i.id));
    const hidden = new Set(items.some((i) => i.sofa) ? (box.dataset.hideWithSofa || '').split(',').map((h) => h.trim()).filter(Boolean) : []);
    const cartKey = [...inCart].sort().join(',');
    let lists = await Promise.all(seeds.map((id) => fetchRecs(box, id, cartKey)));
    if (lists.some((l) => l === null)) {
      await wait(700);
      lists = await Promise.all(seeds.map((id) => fetchRecs(box, id, cartKey)));
    }
    lists = lists.map((l) => l || []);
    if (mine !== run || !box.isConnected) return;
    const seen = new Set();
    const pool = [];
    const push = (c) => { if (!seen.has(c.id) && !inCart.has(c.id) && !hidden.has(c.handle)) { seen.add(c.id); pool.push(c); } };
    lists.forEach((l) => l.forEach(push));
    if (!pool.length) {
      const tpl = box.querySelector('template[data-ocd-recs-fallback]');
      if (tpl) [...tpl.content.querySelectorAll('[data-ocd-rec]')].forEach((el) => push({ id: el.dataset.productId, handle: el.dataset.handle, html: el.outerHTML }));
    }
    const wanted = pool.slice(0, Number(box.dataset.limit) || 4);
    track.innerHTML = wanted.map((c) => c.html).join('');
    const colours = byPrice.map((i) => norm(i.colour)).filter(Boolean);
    track.querySelectorAll('[data-ocd-rec]').forEach((card, i) => {
      card.style.animationDelay = `${i * 50}ms`;
      matchColour(card, colours);
    });
    box.hidden = wanted.length === 0;
    afterRender(box);
  }
  function afterRender(box) {
    bindTrack(box);
    const t = trackOf(box);
    if (t) t.scrollLeft = 0;
    requestAnimationFrame(() => navState(box));
  }

  function matchColour(card, colours) {
    const sel = card.querySelector('[data-ocd-rec-select]');
    if (!sel) return;
    for (const c of colours) {
      const opt = [...sel.options].find((o) => !o.disabled && (o.dataset.keys || '').includes(`|${c}|`));
      if (opt) { sel.value = opt.value; break; }
    }
    sync(card);
  }

  function sync(card) {
    const sel = card.querySelector('[data-ocd-rec-select]');
    if (!sel) return;
    const opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    const btn = card.querySelector('[data-ocd-rec-add]');
    if (btn) { btn.dataset.variantId = opt.value; btn.disabled = opt.disabled; btn.classList.remove('is-added'); }
    const price = card.querySelector('[data-ocd-rec-price]');
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    const img = card.querySelector('[data-ocd-rec-img]');
    if (img && opt.dataset.img && img.getAttribute('src') !== opt.dataset.img) img.src = opt.dataset.img;
  }

  async function add(btn) {
    const d = drawer();
    const id = Number(btn.dataset.variantId);
    if (!d || !id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    try {
      const res = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: [d.dataset.sectionId], sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Error');
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      await wait(450);
      const cart = await (await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } })).json();
      cart.sections = data.sections;
      const ps = window.FoxTheme && window.FoxTheme.pubsub;
      if (ps) ps.publish(ps.PUB_SUB_EVENTS.cartUpdate, { cart }); // theme re-renders the drawer, then fires cart:updated
      else window.location.reload();
      requestAnimationFrame(() => refresh());
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.title = err.message;
      btn.animate && btn.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(0)' }], { duration: 260 });
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('cart-drawer [data-ocd-rec-add]');
    if (btn) { e.preventDefault(); add(btn); }
  });
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('cart-drawer [data-ocd-rec-select]');
    if (sel) sync(sel.closest('[data-ocd-rec]'));
  });
  document.addEventListener('cart:updated', () => refresh());
  document.addEventListener('drawer:handleAfterShow', (e) => { if (e.target && e.target.matches && e.target.matches('cart-drawer')) refresh(); });

  const watch = () => {
    const d = drawer();
    if (!d) return;
    new MutationObserver(() => {
      const box = recsEl();
      if (d.hasAttribute('open') && box && (box.dataset.stale !== '' || !box.querySelector('[data-ocd-rec]'))) refresh();
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  window.ocDrawer = { refresh };
})();
